import React from 'react'
import { startOfDay, endOfDay } from 'date-fns'

import TaskWidget from '@SonarCX/components/molecules/TaskWidget'
import TaskRow from '../TaskRow'
import Information from '../Information'

import useDashboardTasks from '../../hooks/useDashboardTasks'
import useStyles from './styles'

type DueTodayProps = {
  mineOnly: boolean
}

const DueToday: React.FC<DueTodayProps> = ({ mineOnly }) => {
  const { getKey, formatTasks } = useDashboardTasks({
    mineOnly,
    dateRangeStart: startOfDay(new Date()),
    dateRangeEnd: endOfDay(new Date())
  })

  const classes = useStyles()

  return (
    <TaskWidget
      title='Due Today'
      getKey={getKey}
      format={formatTasks}
      rowRenderer={TaskRow}
      noTasksText='No tasks due today'
      className={classes.title}
      infoComponent={
        <Information info='Uncompleted tasks that are due before the end of today' />
      }
    />
  )
}

export default DueToday
